module.exports = __webpack_public_path__ + "img/ansi.bb9a4955.png";